import React, { createContext, useContext, useState, useEffect } from 'react';
import { t, languages } from '../lib/i18n';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('language') || 'ro';
  });

  const isRTL = lang === 'ar';

  useEffect(() => {
    localStorage.setItem('language', lang);
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang, isRTL]);

  const translate = (key) => t(lang, key);

  const value = {
    lang,
    setLang,
    isRTL,
    t: translate,
    languages,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
